module.exports = __webpack_public_path__ + "static/hubble-d3c07bd2fd7e096c52872012220e5545.jpg";